<div class="app-loader" [ngClass]="{ 'app-loader--active': loaderStatus }">
    <div class="app-loader--content">
      <mat-spinner [diameter]="25"></mat-spinner>
      <div class="app-loader--content-text">Please wait...</div>
    </div>
  </div>